import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';

import React, { useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { useReturnsTabContext } from '../hooks/use-returns-tab-context';
import Global from '../../../../../../store/global-selectors';
import { LocaleContext } from '../../../../../../intl/locale-context-provider';
import { getLink } from '../../../../../../services/link-service';
import { linkIDs } from '../../../../../../services/link-service/links';

import style from './style.module.less';

const messages = defineMessages({
  learnMoreAboutAdvancedReturns: {
    description: 'Link to learn more about advanced returns',
    defaultMessage: 'Learn more about {marketplaceName} Returns & Exchanges',
    id: 'PMQe/5',
  },
  learnMoreAboutStandardReturnsPortal: {
    description: 'returnsSettings.learnMoreAboutStandardReturnsPortal',
    defaultMessage: 'Learn about the standard branded returns portal',
    id: '2rC5Uh',
  },
});

/**
 * Returns tab learn more link component
 * Displays a link to learn more about returns functionality
 * @returns {React.ReactElement|null} The Returns tab learn more link or null if it shouldn't be displayed
 */
export const ReturnsTabLearnMoreLink = () => {
  const { locale } = useContext(LocaleContext);
  const homeCountry = useSelector(Global.selectSellerHomeCountry);
  const { supportsEnhancedReturns, marketplaceName } = useReturnsTabContext();
  const text = supportsEnhancedReturns ? (
    <FormattedMessage {...messages.learnMoreAboutAdvancedReturns} values={{ marketplaceName }} />
  ) : (
    <FormattedMessage {...messages.learnMoreAboutStandardReturnsPortal} />
  );
  const articleLink = getLink(linkIDs.BrandedReturns, homeCountry, locale);

  /**
   * We don't have a KB link for enhanced returns yet.
   */
  if (supportsEnhancedReturns) return null;

  return (
    <Button className={style.learnMoreLink} href={articleLink} rel='noreferrer' target='_blank' theme='link'>
      <Text textType={TextType.Paragraph} value={text} />
      <FontAwesomeIcon className={style.learnMoreIcon} icon={faArrowUpRightFromSquare} />
    </Button>
  );
};
